import React from 'react'

function Accessibility() {
    return (
        <div className="container py-5">
            <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4 p-md-5">
                    <h5 className="fw-bold text-success border-bottom pb-3 mb-4">
                        Accessibility
                    </h5>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        We are committed to ensure that, this website is accessible to all users irrespective of device in use, technology or ability. It has
                        been built with an aim to provide maximum accessibility and usability to its visitors. As a result, this website can be viewed from a
                        variety of devices, such as web-enabled mobile devices, WAP phones, PDAs, and so on. We have put in our best efforts to ensure that
                        all information on this website is accessible to people with disabilities. For example, a user with visual disability can access this website
                        using assistive technologies, such as screen readers and magnifiers.
                    </p>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >

                        We also aim to be standards compliant and follow principles of usability,GIGW standards and universal design, which should
                        help all visitors of this website
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Accessibility